export type AppMode = 'home' | 'edit' | 'present' | 'speaker';

export type Route = {
  mode: AppMode;
  deck: string;
  page: number;
  step: number;
  legacySlide?: string;
  /** Present only when this view has opted into a remote room. */
  room?: string;
};

export function readRoute(): Route {
  const path = location.pathname.split('/').filter(Boolean)[0] ?? '';
  const mode: AppMode =
    path === 'edit' || path === 'present' || path === 'speaker' ? path : 'home';
  const query = new URLSearchParams(location.search);
  return {
    mode,
    deck: query.get('deck') ?? '',
    page: Math.max(1, Number(query.get('page')) || 1),
    step: Math.max(0, Number(query.get('step')) || 0),
    legacySlide: query.get('slide') ?? undefined,
    room: query.get('room') ?? undefined,
  };
}

export function routeUrl(
  mode: Exclude<AppMode, 'home'>,
  deck: string,
  page: number,
  step = 0,
  room?: string,
): string {
  const query = new URLSearchParams({deck, page: String(page)});
  if (step > 0) query.set('step', String(step));
  // Carried through every navigation: losing the room on the first slide
  // change would drop the phone mid-sentence.
  if (room) query.set('room', room);
  return `/${mode}?${query}`;
}

export function syncRoute(
  mode: Exclude<AppMode, 'home'>,
  deck: string,
  page: number,
  step: number,
  room?: string,
) {
  history.replaceState(null, '', routeUrl(mode, deck, page, step, room));
}
